<template>
	<div id="page_contact">
		<div class="banner">
			<img src="../assets/img/contact_banner.jpg" alt="" class="bg" />
			<div class="textbox">
				<h2 class="wow fadeInDown">
					Sound issues? Let Brotex help you and stay in touch
				</h2>
			</div>
			<div class="crumb">
				<router-link to="./Index">HOME</router-link>
				<router-link to="./Contact">Contact</router-link>
			</div>
		</div>
		<div id="part1" class="full">
			<div class="formbox">
				<div class="mainTitle1 textbox">
					<h3>Contact Us</h3>
				</div>
				<dl>
					<dd class="inputbox">
						<input
							type="text"
							placeholder="Name*"
							v-model="form.name"
						/>
						<input
							type="text"
							placeholder="Email*"
							v-model="form.email"
						/>
					</dd>
					<dd>
						<p>
							Do you know the ambient noise level of your
							conference room?
						</p>
						<div class="radiobox">
							<label
								>Yes<input name="q1" type="radio" value=""
							/></label>
							<label
								>No<input name="q1" type="radio" value=""
							/></label>
						</div>
					</dd>
					<dd>
						<p>
							Can you provide 1/1 or 1/3/8 audio spectrum of
							background noise of the building?
						</p>
						<div class="radiobox">
							<label
								>Yes<input name="q2" type="radio" value=""
							/></label>
							<label
								>No<input name="q2" type="radio" value=""
							/></label>
						</div>
					</dd>
					<dd class="selectLine">
						<p>Your pre-ordered products will install in :</p>
						<el-select v-model="value1" placeholder="Please Check">
							<el-option
								v-for="item in options1"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</dd>
				</dl>
				<dl v-show="moreflag">
					<dd class="selectLine">
						<p>This space is used for:</p>
						<el-select v-model="value2" placeholder="Please Check">
							<el-option
								v-for="item in options2"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</dd>
					<dd class="selectLine">
						<p>
							How's the surrounding environment of the meeting
							room:
						</p>
						<el-select v-model="value3" placeholder="Please Check">
							<el-option
								v-for="item in options3"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</dd>
					<dd>
						<p>
							Can you provide 1/1 or 1/3/8 audio spectrum of
							background noise of the building?
						</p>
						<div class="radiobox">
							<label
								>Yes<input name="q3" type="radio" value=""
							/></label>
							<label
								>No<input name="q3" type="radio" value=""
							/></label>
						</div>
					</dd>
					<dd class="area">
						<p>Detailed information about your space:</p>
						<div class="line">
							<p>a. Space size:</p>
							<input type="text" placeholder="(cm)" />
						</div>
						<div class="line">
							<p>
								b. What is the total number of building floors
								where the meeting room (hall) is scheduled to be
								located?
							</p>
							<input type="text" placeholder="Floors Quantity" />
						</div>
						<div class="line">
							<p>
								c. On which floor is this meeting room (hall)
								scheduled to be located?
							</p>
							<input type="text" placeholder="which Floor" />
						</div>
						<div class="line">
							<p>
								d. How many people can this space hold at most?
							</p>
							<input type="text" placeholder="Number Of People" />
						</div>
					</dd>
				</dl>
				<div class="submitbox">
					<div
						class="mainBtn1 hbutton_isi"
						@click="submit()"
						v-loading="loading"
					>
						SEND
					</div>
					<div class="right">
						<p v-text="moreflag ? 'Show Less' : 'Show More'"></p>
						<img
							src="../assets/img/contact_downicon.jpg"
							alt=""
							class="more"
							:class="moreflag == true ? 'on' : ''"
							@click="moreflag = !moreflag"
						/>
					</div>
				</div>
			</div>
		</div>
		<div id="part2">
			<div class="left">
				<img src="../assets/img/contact_part2img.jpg" alt="" />
			</div>
			<div class="right">
				<div class="mainTitle1 textbox">
					<h3>Brotex Head Office</h3>
					<p>
						Want to speak with a live person or send us an email?<br />Stay
						connected, and our journey of acoustic sound begins
						here.
					</p>
				</div>
				<dl>
					<!--          <dd>Add: Guangdong City, Guangdong Province, China.</dd>-->
					<!--          <dd>Tel: 020-87390340</dd>-->
					<!--          <dd>Fax: 020-87398749</dd>-->
					<!--          <dd>E-mail: 2355517403@qq.com</dd>-->
					<!--          <dd>Skype: amy.wang198</dd>-->
					<!--          <dd>Whatsapp: 0086 13510670047</dd>-->
					<dd>Add: Guangdong City, Guangdong Province, China.</dd>
					<dd>Tel: +86 13794082523</dd>
					<!--          <dd>Fax: +86 13794082523</dd>-->
					<dd>E-mail: info@brotexacoustic.com</dd>
					<dd>Whatsapp: +86 13794082523</dd>
					<dd>Wechat: +86 13794082523</dd>
					<dd>Website: https://brotex168.en.made-in-china.com</dd>
					<!--          <dd>Stay connected, and our journey begins here.</dd>-->
				</dl>
			</div>
		</div>
	</div>
</template>

<script>
	import { WOW } from "wowjs"
	import * as $request from "../api"
	export default {
		name: "Contact",
		metaInfo: {
			title: "Guangdong Brotex Acoustic Technology Co.,Ltd | Contact"
		},
		components: {},
		data() {
			return {
				loading: false,
				form: {
					name: "",
					email: "",
					// tel: '',
					// QnM: '',
					// VerifyCode: '',
					message: "empty"
				},
				options1: [
					{
						value: "选项1",
						label: "The meeting room of the company"
					},
					{
						value: "选项2",
						label: "A big conference hall"
					},
					{
						value: "选项3",
						label: "Multifunctional conference hall"
					}
				],
				value1: "",
				options2: [
					{
						value: "选项1",
						label: "The meeting room of the company"
					},
					{
						value: "选项2",
						label: "A big conference hall"
					},
					{
						value: "选项3",
						label: "Multifunctional conference hall"
					}
				],
				value2: "",
				options3: [
					{
						value: "选项1",
						label: "The meeting room of the company"
					},
					{
						value: "选项2",
						label: "A big conference hall"
					},
					{
						value: "选项3",
						label: "Multifunctional conference hall"
					}
				],
				value3: "",
				moreflag: false
			}
		},
		methods: {
			submit() {
				const is = this.formCheck(this.form, 2)
				// console.log(is)
				if (is.is_ok == true) {
					if (this.loading == false) {
						this.loading = true
						$request.postForm(this.form).then((res) => {
							this.loading = false
							if (res.code == 200) {
								this.$message({
									message: "Successed!",
									type: "success",
									offset: 430
								})
								setTimeout(() => {
									this.$google()
								}, 2000)
							} else {
								this.$message({
									message: "Failed!",
									type: "error",
									offset: 430
								})
							}
						})
					}
				} else if (is.is_empty == true) {
					// this.loading=false
					// this.$message.warning('The form can\'t be empty!');
					this.$message({
						message: "The form can't be empty!",
						type: "warning",
						offset: 430
					})
				} else if (is.email_ok != true) {
					this.$message({
						message: "The mailbox format is incorrect!",
						type: "error",
						offset: 430
					})
				} else {
					this.$message({
						message: "Failed!",
						type: "error",
						offset: 430
					})
				}
			}
		},
		created() {
			this.$emit("getnav", 5)
		},
		mounted() {
			this.$nextTick(() => {
				let wow = new WOW({
					live: false
				})
				wow.init()
			})
		}
	}
</script>

<style lang="less" scoped>
	#page_contact {
		.banner {
			height: 536px;
			position: relative;
			z-index: 1;
			padding: 230px 0 0 0px;
			text-align: center;
			overflow: hidden;
			.bg {
				position: absolute;
				bottom: 0;
				right: 0;
				z-index: -1;
			}
			.textbox {
				h2 {
					color: white;
				}
			}
			.crumb {
				font: 20px Poppins-SemiBold;
				margin-top: 60px;
				a {
					color: white;
					&:not(:last-child):after {
						content: ">";
						margin: 0 20px;
					}
					&:last-child {
						border-bottom: 1px solid white;
					}
				}
			}
		}
		#part1 {
			background: #f5f5f5;
			.formbox {
				background: white;
				padding: 70px 135px;
				.mainTitle1 {
					margin-bottom: 20px;
					h3:before {
						left: -5%;
					}
				}
				dd {
					display: flex;
					justify-content: space-between;
					margin-bottom: 25px;
					p {
						color: @main-c5;
						max-width: 80%;
					}
					.radiobox {
						display: flex;
						align-items: center;
					}
					label {
						display: inline-flex;
						align-items: center;
						margin-left: 20px;
						color: @main-c5;
					}
					input[type="radio"] {
						width: 20px;
						height: 20px;
						margin-left: 10px;
						cursor: pointer;
					}
					//input[type='radio']{width: 0;height: 0;position: relative;margin-left: 20px;
					//  &:before{content: ' ';background: white;width: 20px;height: 20px;border: 1px solid @main-c1;display: inline-flex;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);cursor: pointer;}
					//}
					&:not(.inputbox) {
						background: #f5f5f5;
						padding: 15px 40px;
						font: 22px Poppins-Regular;
					}
					input {
						border: none;
						background: #f5f5f5;
						padding: 15px 40px;
						font: 22px Poppins-Regular;
						width: calc(50% - 12.5px);
						&::-webkit-input-placeholder {
							font: 22px Poppins-Regular;
							color: @main-c5;
						}
					}
					/deep/ .el-select {
						width: 50%;
						.el-input__inner {
							border-radius: 0;
							border-color: @main-c5;
							font: 18px Poppins-Regular;
							&::-webkit-input-placeholder {
								color: @main-c5;
								font: 18px Poppins-Regular;
							}
						}
						.el-input__suffix i {
							color: @main-c5;
						}
					}
					&.selectLine {
						p {
							max-width: 50%;
						}
					}
					&.area {
						display: block;
						color: @main-c5;
						.line {
							padding: 15px 0;
							display: flex;
							justify-content: space-between;
							align-items: center;
							p {
								max-width: 70%;
								line-height: 24px;
							}
							input {
								background: white;
								padding: 5px 20px;
								width: 30%;
							}
						}
					}
				}
			}
			.submitbox {
				border-top: 2px solid #e8e8e8;
				padding: 28px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.right {
					display: flex;
					align-items: center;
					p {
						font: 20px Poppins-Medium;
						margin-right: 20px;
						color: @main-c4;
					}
					.more {
						cursor: pointer;
						&.on {
							transform: rotate(180deg);
						}
					}
				}
			}
		}
		#part2 {
			display: flex;
			justify-content: space-between;
			.left {
				width: 47.5%;
				img {
					width: 100%;
				}
			}
			.right {
				width: 45%;
				.mainTitle1 {
					margin-bottom: 60px;
					h3:before {
						left: -7%;
					}
					p {
						width: 100%;
					}
				}
				dd {
					font: 22px Poppins-Medium;
					color: @main-c4;
					padding: 10px 0;
				}
			}
		}
	}
</style>
